// `as const` keeps the keys narrow (so MessageKey is a finite literal union)
// while we expose values as plain strings for the locale dictionaries to satisfy.
const dict = {
  'home.title': "L'Infiltré",
  'home.subtitle': 'Crisis in the neighborhood. Pick a mode.',
  'home.resume.eyebrow': 'Resume',
  'home.resume.label': 'Continue saved game',
  'home.standalone.eyebrow': 'Local',
  'home.standalone.label': 'Play on this device',
  'home.standalone.description': 'Works offline. One device, multiple players.',
  'home.online.eyebrow': 'Online',
  'home.online.label': 'Private room',
  'home.online.description': 'Coming next.',
  'home.version': 'v0.0.0',
  'home.players_minutes': '3–12 players · 5 min / round',
  'home.eyebrow': 'Crisis · Infiltrators among the Flics',
  'home.lede':
    'The Flics share a safe word. An Infiltré sees a similar — but different — word. Sniff out the imposter before they pin it on you.',
  'home.tagline.same_word': 'Same safe word. Almost.',
  'home.tagline.almost': 'One of you is infiltrated.',
  'home.tagline.spot_the_imposter': 'Spot the Infiltré.',
  'home.rules.cta': 'How to play',

  'rules.eyebrow': 'The briefing · 30 seconds',
  'rules.title': 'How to play',
  'rules.sub': 'Three rules. One Infiltré. Don’t get caught.',
  'rules.step1.title': 'Each player gets a secret word.',
  'rules.step1.body':
    'The Flics share a safe word. The Infiltré sees a similar — but different — word. The Clochard sees nothing: a wandering soul from the neighborhood, just trying to guess.',
  'rules.step2.title': 'Take turns describing your word.',
  'rules.step2.body':
    'One word, no rhymes, no spelling. Infiltrés must wing it without giving themselves away.',
  'rules.step3.title': 'Vote out the Infiltré.',
  'rules.step3.body':
    "After everyone speaks, the table votes. If you eliminate the Clochard, they get a final guess at the Flics' word to steal the win.",
  'rules.footer': 'Best with 4–8 friends. Pass the device around. Trust no one.',
  'rules.got_it': 'Got it',

  'setup.count.heading': 'How many players?',
  'setup.count.hint': 'Tap the number, then pass the device',
  'setup.count.cta': 'Pass device to player 1',
  'setup.slot.player_label': 'Player {n}',
  'setup.slot.hint': 'Hold to name yourself',
  'setup.slot.welcome': 'Type your name',
  'setup.slot.name_placeholder': 'Your name',
  'setup.slot.confirm': 'Confirm — pass device',
  'setup.slot.duplicate_error': 'This name is already taken.',

  'setup.players.heading': 'Players',
  'setup.players.hint': 'Enter every player. First name is the host.',
  'setup.players.host_placeholder': 'Host name',
  'setup.players.player_placeholder': 'Player {index}',
  'setup.players.add': '+ Add player',
  'setup.players.duplicate_error': 'Names must be unique.',

  'setup.briefing.eyebrow': 'File prep',
  'setup.briefing.title': 'Briefing room',
  'setup.briefing.settings': 'Settings',
  'setup.host_settings.title': 'Room settings',
  'setup.host_settings.eyebrow': 'Host controls · case file',
  'setup.host_settings.hint': 'Tune the round before you deal cards. Only the host sees this.',
  'setup.host_settings.lock_in': 'Lock it in',
  'setup.host_settings.section.mode': 'Game mode',
  'setup.host_settings.section.roles': 'Roles',
  'setup.host_settings.section.pace': 'Pace',
  'setup.host_settings.section.word_pack': 'Word pack',
  'setup.host_settings.infiltre_hint': 'Sees a similar word, has to bluff',
  'setup.host_settings.clochard_label': 'Include a Clochard',
  'setup.host_settings.clochard_hint':
    "Wandering local. Knows nothing. Can steal the win by guessing the Flics' word.",
  'setup.host_settings.timer_hint': 'Seconds per round · 0 = no timer',
  'setup.host_settings.timer_off': 'Off',
  'category.animals': 'Animals',
  'category.food': 'Food',
  'category.objects': 'Objects',
  'category.geography': 'Geography',
  'category.nature': 'Nature',
  'category.sports': 'Sports',
  'category.movies': 'Movies',
  'category.slang': 'Slang',
  'setup.briefing.headline_top': 'Briefing',
  'setup.briefing.headline_bottom': 'room.',
  'setup.briefing.lede':
    'Recruit your suspects. Tap a polaroid to rename. Words are sealed — even from the host.',
  'setup.briefing.recruit': 'Recruit',
  'setup.briefing.suspects': 'Suspects',
  'setup.briefing.need_more': 'Recruit {needed} more',
  'setup.briefing.deal_cards': 'Start round',
  'setup.briefing.sealed_hint': 'Word pair sealed — nobody sees it yet.',
  'setup.mugshot.customize_aria': 'Customize face',
  'setup.mugshot.title': 'Mugshot',
  'setup.mugshot.phase': 'File 01',
  'setup.mugshot.subtitle': 'suspect identifier',
  'setup.mugshot.section.identity': 'Identity',
  'setup.mugshot.section.features': 'Features',
  'setup.mugshot.randomize': 'Randomize',
  'setup.mugshot.close': 'Close',
  'setup.mugshot.done': 'Done',
  'setup.mugshot.category.menton': 'Chin',
  'setup.mugshot.category.nez': 'Nose',
  'setup.mugshot.category.bouche': 'Mouth',
  'setup.mugshot.category.moustache': 'Moustache',
  'setup.mugshot.category.yeux': 'Eyes',
  'setup.mugshot.category.sourcils': 'Eyebrows',
  'setup.mugshot.category.cheveux': 'Hair',
  'setup.mugshot.category.accessoire': 'Accessory',
  'setup.recruit.sealed_eyebrow': 'Sealed · do not open',

  'setup.options.heading': 'Options',
  'setup.options.include_clochard': 'Include a Clochard',
  'setup.options.discussion_seconds': 'Discussion timer',
  'setup.options.discussion_seconds_hint': 'Seconds before vote opens. 0 = manual.',
  'setup.options.locale': 'Language',

  'locale.en': 'English',
  'locale.fr': 'Français',
  'locale.es': 'Español',
  'locale.de': 'Deutsch',
  'locale.pt': 'Português',

  'setup.start': 'Start game',

  'play.no_active_game': 'No active game.',
  'play.go_home': 'Go home',
  'play.connecting': 'Connecting…',
  'play.phase_label': 'Phase: {phase}',

  'play.privacy_gate.pass_to': 'Pass to',
  'play.privacy_gate.hold_to_reveal': 'Press and hold to reveal',
  'play.privacy_gate.tap_to_reveal': 'Click to reveal',
  'play.privacy_gate.hold_to_see_word': 'Hold to see your word',
  'play.privacy_gate.tap_to_see_word': 'Tap to see your word',
  'play.privacy_gate.hold_to_vote': 'Hold to vote',
  'play.privacy_gate.done': 'Done — pass device',
  'play.pass_device.eyebrow': 'Hand device to',
  'play.pass_device.dossier': 'Dossier · {n}/{total}',
  'play.pass_device.no_peeking': '— No peeking. The walls have ears.',
  'play.pass_device.ready': "I'm ready",

  'play.handoff.all_done_eyebrow': 'All players done',
  'play.handoff.all_revealed_title': 'All players ready',
  'play.handoff.all_revealed_description': 'Time to discuss. Speak in order.',
  'play.handoff.continue': 'Continue',
  'play.handoff.all_voted_title': 'All votes in',
  'play.handoff.all_voted_description': 'Tap to reveal.',
  'play.handoff.reveal': 'Reveal',

  'pause.button': 'Pause',
  'pause.eyebrow': 'Game paused · off the record',
  'pause.title': 'Take a beat.',
  'pause.sub': 'Pick up where you left off, or pull the plug.',
  'pause.resume.label': 'Resume',
  'pause.resume.sub': 'Back to the action.',
  'pause.rules.label': 'How to play',
  'pause.rules.sub': 'Refresh the rules.',
  'pause.quit.label': 'Quit to home',
  'pause.quit.sub': 'End the game. Settings kept.',
  'pause.recap.label': 'Round recap',
  'pause.recap.sub': 'See the case log so far.',

  'recap.eyebrow_between': 'Case log · round closed',
  'recap.eyebrow_end': 'Case log · full dossier',
  'recap.title_between': 'Round recap',
  'recap.title_end': 'How it played out',
  'recap.sub_between': 'What happened so far. Use it. Or don’t.',
  'recap.sub_end': 'Every round, every elimination, in order.',
  'recap.empty': 'No rounds played yet — case log is empty.',
  'recap.still_in_room': 'Still in the room',
  'recap.eliminated_meta': 'Eliminated · {count} left in',
  'recap.round_short': 'Rnd',
  'recap.close': 'Close',

  'round.your_role': 'Your role',
  'round.your_card': 'Your card',
  'round.your_word': 'Your word',
  'round.no_word': 'No word',
  'round.no_word_hint': 'Bluff your way through.',

  'round.speaking.heading': 'Speaking order',
  'round.speaking.hint': "Each player gives one clue, in order. Don't say the word directly.",
  'round.speaking.ready_to_vote': 'Ready to vote',
  'round.speaking.order_eyebrow': 'IN ORDER',
  'round.speaking.order_title': 'Around the table',

  'round.vote.eyebrow': '{name} — your vote',
  'round.vote.heading': 'Pin the Infiltré',

  'round.result.eyebrow': 'Round closed',
  'round.result.complete_eyebrow': 'Dossier',
  'round.result.voted_out_eyebrow': 'Voted out',
  'play.clochard.spotlight': 'Spotlight',
  'play.clochard.last_words': '{name}, last words.',
  'play.clochard.one_guess': 'One guess',
  'round.result.cast_eyebrow': 'cast revealed',
  'round.result.suspects_count': 'suspects',
  'round.result.win_team.flic': 'FLICS',
  'round.result.win_team.infiltre': 'INFILTRÉS',
  'round.result.win_team.clochard': 'CLOCHARD',
  'round.result.win_verb.flic': 'WIN.',
  'round.result.win_verb.infiltre': 'WIN.',
  'round.result.win_verb.clochard': 'WINS.',
  'round.result.sub_flic': '— the table sniffed them out.',
  'round.result.sub_infiltre': '— hidden in plain sight.',
  'round.result.sub_clochard': '— one guess. Pure nerve.',
  'round.result.replay_cta': 'Replay',
  'round.result.new_dossier_cta': 'New dossier',
  'round.result.title': 'Round result',
  'round.result.title_finished': 'Game over',
  'round.result.still_in': 'Still in the game',
  'round.eliminated': 'Eliminated',
  'round.winner': 'Winner',
  'round.case_closed': 'Case closed',
  'round.flic_word': 'Flics’ word',
  'round.infiltre_word': 'Infiltré word',
  'round.next_round': 'Next round',
  'round.back_home': 'Back to home',
  'round.result.view_case_log_one': 'View case log · 1 round',
  'round.result.view_case_log_many': 'View case log · {count} rounds',
  'round.rematch': 'Rematch',
  'round.replay.button': 'Play another round',
  'round.replay.waiting': 'Waiting ({count}/{needed} ready)',
  'round.replay.requested': 'You voted to continue',
  'round.eliminate.heading': 'Who got voted out?',
  'round.eliminate.eyebrow': 'Vote',
  'round.eliminate.host_hint': 'Host · tap the loser',
  'round.eliminate.subtitle': 'Vote out loud · round table',
  'round.eliminate.body':
    'Each living player points at someone, no second-guessing. Tally hands around the table — the host taps whoever lost.',
  'round.eliminate.cta_idle': 'Tap a player above',
  'round.eliminate.cta_picked': 'Eliminate {name}',
  'round.speaking.rule_eyebrow': 'Rule of the round',
  'round.speaking.rule_line1': 'One word.',
  'round.speaking.rule_line2': 'No repeats.',
  'round.discuss.heading': 'Discussion',
  'round.discuss.eyebrow_calm': 'Talk · accuse · defend',
  'round.discuss.eyebrow_danger': 'Time running out',
  'round.discuss.seconds_label': 'Seconds',
  'round.discuss.tick_calm.0': "“Who's bluffing?”",
  'round.discuss.tick_calm.1': "“I don't buy it.”",
  'round.discuss.tick_calm.2': '“Prove it.”',
  'round.discuss.tick_calm.3': '“You first.”',
  'round.discuss.tick_hot.0': "“Time's up.”",
  'round.discuss.tick_hot.1': '“Pick one.”',
  'round.discuss.tick_hot.2': '“Decide.”',

  'play.clochard.title': 'Clochard caught',
  'play.clochard.description': "{name}, guess the Flics' word to win.",
  'play.clochard.placeholder': 'Your guess',
  'play.clochard.submit': 'Submit guess',

  'role.flic': 'Flic',
  'role.infiltre': 'Infiltré',
  'role.clochard': 'Clochard',

  'home.online_join.eyebrow': 'Online',
  'home.online_join.label': 'Join',
  'home.online_join.description': 'Got an invite? Punch in the code.',

  'home.discord.eyebrow': 'Voice channel · Activity',
  'home.discord.heading': 'Play with your channel',
  'home.discord.tagline': 'Everyone in voice, one shared dossier.',
  'home.discord.lede': 'Everyone in this voice channel joins the same dossier.',
  'home.discord.lede_named': 'Hey {name} — pull everyone in voice into the same dossier.',
  'home.discord.start_activity': 'Enter Activity room',
  'home.discord.start_busy': 'Opening dossier…',
  'home.discord.join_with_code': 'Join a different room with a code',
  'home.discord.no_instance': 'Discord Activity not detected — try relaunching the Activity.',
  'home.discord.sdk_failed': 'Discord SDK failed to start. Retry to try again.',
  'home.discord.sdk_retry': 'Retry connection',
  'home.discord.solo_label': 'Play on this device instead',
  'home.online.unavailable': 'Online mode unavailable — server unreachable.',

  'online.create.eyebrow': 'New case · open file',
  'online.create.heading': 'Create a room',
  'online.create.hint': 'Pick a name. We will generate a code to share with friends.',
  'online.create.name_placeholder': 'Your name',
  'online.create.submit': 'Create room',
  'online.create.creating': 'Creating…',

  'online.join.eyebrow': 'Walk in · briefing room',
  'online.join.heading': 'Join a room',
  'online.join.hint': 'Enter the code your friend shared.',
  'online.join.name_placeholder': 'Your name',
  'online.join.code_placeholder': 'ROOM CODE',
  'online.join.submit': 'Join',
  'online.join.joining': 'Joining…',

  'online.lobby.players': 'Players',
  'online.lobby.briefing_room': 'Briefing room',
  'online.lobby.host_badge': 'Host',
  'online.lobby.you_badge': 'you',
  'online.lobby.reconnecting_badge': 'reconnecting',
  'online.lobby.offline_badge': 'offline',
  'online.toast.room_not_found': 'Room not found',
  'online.toast.room_full': 'Room is full',
  'online.toast.kicked_after_grace': 'You were disconnected for too long',
  'online.toast.unauthorized': 'Session expired',
  'online.toast.presence_online': '{name} reconnected',
  'online.toast.presence_reconnecting': '{name} is reconnecting',
  'online.toast.presence_offline': '{name} disconnected',
  'online.toast.server_error.actor_mismatch': "That action wasn't from your session",
  'online.toast.server_error.unknown_player': 'Player not in this room',
  'online.toast.server_error.name_required': 'Name cannot be empty',
  'online.toast.server_error.invalid_message': 'Invalid request',
  'online.toast.server_error.unauthorized': 'Not allowed',
  'online.toast.server_error.only_host': 'Only the host can do that',
  'online.toast.server_error.wrong_phase': 'Action came too late — round moved on',
  'online.toast.server_error.invalid_target': 'Invalid target',
  'online.toast.server_error.not_your_guess': "It's not your turn to guess",
  'online.toast.server_error.not_a_member': "You're not in this room",
  'online.toast.server_error.not_enough_players': 'Need more players',
  'online.toast.server_error.too_many_players': 'Too many players',
  'online.toast.server_error.room_already_exists': 'Room already exists',
  'online.toast.server_error.no_session': 'Session expired — reconnecting',
  'online.toast.server_error.create_via_rest': 'Create rooms via the home page',
  'online.toast.server_error.system_only_message': 'Internal message blocked',
  'online.toast.server_error.internal': 'Unexpected server error',
  'online.toast.server_error.generic': 'Server error: {message}',
  'online.lobby.waiting_host': 'Waiting for the host to start…',
  'online.lobby.start_game': 'Start game',
  'online.lobby.need_more_players': 'Need at least 3 players',

  'online.room.code_label': 'Room code',
  'online.room.code_hide': 'Hide room code',
  'online.room.code_show': 'Show room code',
  'online.room.copy': 'Copy',
  'online.room.copied': 'Copied!',

  'online.banner.connecting': 'Reconnecting…',
  'online.banner.error': 'Connection lost. Retrying.',

  'online.reveal.acknowledge': 'Got it',
  'online.reveal.waiting.eyebrow': 'PHASE 01 · BRIEFING',
  'online.reveal.waiting.title': 'Briefing in progress',
  'online.reveal.waiting.descriptor': '— waiting on {pending} agent(s)',
  'online.reveal.waiting.center_label': 'ready',
  'online.discuss.host_open_vote_button': 'Ready to vote',
  'online.discuss.waiting_host': 'Waiting for the host to open the vote…',
  'online.discuss.timer_label': 'Vote opens in {time}',
  'online.discuss.timer_expired': 'Opening vote…',
  'online.discuss.timer_eyebrow': 'Vote opens in',
  'online.vote.spectating': 'You are eliminated. Watching the round.',
  'online.vote.waiting.eyebrow': 'PHASE 03 · VOTE',
  'online.vote.waiting.title': 'Ballots in transit',
  'online.vote.waiting.descriptor': '— {pending} ballot(s) outstanding',
  'online.vote.waiting.center_label': 'voted',
  'online.clochard.spectating': '{name} is taking the last shot.',
  'online.round.waiting_host': 'Waiting for the host…',
  'online.spectator.heading': 'Spectating',
  'online.spectator.eyebrow': 'OFF THE FIELD · STILL WATCHING',
  'online.spectator.eliminated': 'You are out — watching the round.',
  'online.spectator.finished': 'Game over.',
  'online.spectator.flic_word': 'Flics’ word',
  'online.spectator.infiltre_word': 'Infiltré word',
  'online.spectator.phase_label': 'Phase: {phase}',
  'online.host_changed.banner': '{name} is now the host.',
  'online.host_changed.you_banner': 'You are now the host.',

  'platform.error.discord_unavailable': 'Discord features are unavailable here.',
  'platform.error.tauri_unavailable': 'Desktop features are unavailable here.',
  'platform.error.capacitor_unavailable': 'Mobile features are unavailable here.',
  'platform.error.identity_failed': 'Could not sign you in. Please try again.',
  'platform.banner.platform_label': 'Running on {platform}',
  'platform.discord.connecting': 'Connecting to Discord…',
  'platform.discord.authorizing': 'Authorizing with Discord…',
  'platform.tauri.connecting': 'Loading session…',
  'platform.capacitor.connecting': 'Loading session…',

  'a11y.privacy_gate.aria_label': 'Hold to reveal — pass to {name}',
  'a11y.vote_board.candidate_aria_label': 'Vote for {name}',
  'a11y.audio.mute_label': 'Mute sound effects',
  'a11y.audio.unmute_label': 'Unmute sound effects',
  'a11y.audio.volume_label': 'Sound effects volume',

  'nav.brand': "L'Infiltré",
  'nav.back': 'Back',
  'nav.home_label': 'Back to home',
  'nav.settings_label': 'Open settings',

  'settings.title': 'Settings',
  'settings.close': 'Close',
  'settings.section.language': 'Language',
  'settings.language.subtitle': 'choose the interface language',
  'settings.section.theme': 'Theme',
  'settings.theme.noir': 'Noir',
  'settings.theme.party': 'Party',
  'settings.section.layout': 'Layout',
  'settings.layout.auto': 'Auto',
  'settings.layout.mobile': 'Mobile',
  'settings.layout.desktop': 'Desktop',
  'settings.section.audio': 'Audio',
  'settings.audio.mute': 'Mute sound effects',
  'settings.audio.volume': 'Volume',

  'mode.select.heading': 'Choose a mode',
  'mode.select.hint': 'Pick how you want to play. You can change later from settings.',
  'mode.select.coming_soon': 'Coming soon',
  'mode.infiltre_classic.name': "L'Infiltré",
  'mode.infiltre_classic.tagline': 'Flics vs Infiltrés. Vote out who doesn’t fit.',
  'mode.team_deathmatch.name': 'Team Deathmatch',
  'mode.team_deathmatch.tagline': 'Two teams, two words. Find your mates and survive.',

  // Dossier briefing panel — desktop lobby + standalone setup right column.
  'briefing.phase_00': 'Phase 00 · Set the table',
  'briefing.title': 'Briefing',
  'briefing.subtitle': 'set the table before you deal',
  'briefing.mode.label': 'Mode — pick one',
  'briefing.mode.classic': '1 Infiltré · standard',
  'briefing.mode.duo': '2 Infiltrés · 6+ players',
  'briefing.mode.trio': '3 Infiltrés · 9+ players',
  'briefing.mode.clochard': '+ Clochard · 5+ players',
  'briefing.timer.label': 'Discussion · seconds',
  'briefing.clochard.label': 'Include a Clochard',
  'briefing.clochard.hint': '(player without a word)',
  'briefing.footer.ready': 'ready — {count} suspects',
  'briefing.footer.need_more': 'need {count} more',
  'briefing.footer.deal': 'Deal',
  'briefing.tape.briefing_room': 'Briefing room',
  'briefing.tape.how_to_play_l1': 'how to',
  'briefing.tape.how_to_play_l2': 'play ?',

  // Phase headers — pinned cream paper-sheet headers for game-round screens.
  'round.distribution.phase_eyebrow': 'PHASE 01 · HAND-OUT',
  'round.distribution.title': 'Hand-out',
  'round.distribution.descriptor': '— {step} of {total}',
  'round.distribution.tour': 'TURN',
  'round.distribution.no_peeking_tape': 'NO PEEKING',
  'round.dossier.phase_eyebrow': 'PHASE 01 · PERSONAL DOSSIER',
  'round.dossier.title': 'Dossier',
  'round.dossier.descriptor': '— hold to read',
  'round.dossier.field_name': 'NAME',
  'round.dossier.field_role': 'ROLE',
  'round.dossier.field_word': 'CODE WORD',
  'round.dossier.release_to_hide': '— release to hide',
  'round.dossier.close_cta': 'CLOSE DOSSIER',
  'round.speaking.phase_eyebrow': 'PHASE 02 · SPEAKING TURN',
  'round.speaking.descriptor': '— one word, out loud, in order',
  'round.discuss.phase_eyebrow': 'PHASE 03 · OPEN DEBATE',
  'round.discuss.title': 'Debate',
  'round.discuss.descriptor': '— who’s lying ? talk it out.',
  'round.discuss.timer_eyebrow': 'TIMER · TIME REMAINING',
  'round.discuss.timer_calm_sub': '— take your time',
  'round.discuss.timer_danger_sub': '— time is running out',
  'round.discuss.suspects_pill': '{count} suspects in play',
  'round.vote.phase_eyebrow': 'PHASE 04 · VOTE AT THE TABLE',
  'round.vote.title': 'Vote',
  'round.vote.descriptor': '— vote out loud, mark the eliminated',
  'round.verdict.phase_eyebrow': 'PHASE 05 · VERDICT',
  'round.verdict.descriptor': '— suspect goes down',
  'round.verdict.role_revealed': 'ROLE REVEALED',
  'round.verdict.role_tagline.flic': 'real word · innocent',
  'round.verdict.role_tagline.infiltre': 'fake word · guilty',
  'round.verdict.role_tagline.clochard': 'no word · joker',
  'round.verdict.stamp': 'ELIMINATED',
  'round.verdict.no_elimination.title': 'No verdict',
  'round.verdict.no_elimination.stamp': 'FILE DEFERRED',
  'round.verdict.no_elimination.descriptor': '— votes split, the room moves on',
  'round.verdict.no_elimination.still_in': 'Still in play',
} as const;

// Keys are the canonical set; values widen to plain strings so other locale
// dictionaries don't have to match each English string literally.
export type Messages = { readonly [K in keyof typeof dict]: string };

export const en: Messages = dict;
